import React, { forwardRef, useRef, useEffect, useCallback } from 'react';
import { Input } from 'antd';
import { UploadAndViewImage, UploadAndViewPdf, UploadAndViewHtml } from '@components';
import { useLocation } from 'react-router-dom';
// import LinkInput from '@components/linkInput/linkInput';
import { INTEGRATION_TYPES } from '@model';
import TextContainerInlineInput from '@components/textContainerModal/TextContainerInlineInput';
import LinkEditorPopup from './linkEditorPopup';
import { isHtmlModuleEnabled } from '@utils/htmlModuleConfig';
const { TextArea } = Input;

let activeId = '';
const setCaretPositionEnd = (elementId) => {
  const element = document.getElementById(elementId);
  const pos = element?.value?.length || 0;
  element.setSelectionRange(pos, pos);
};

const ExtendableTextArea = forwardRef(
  (
    {
      shouldExtend,
      autoSize,
      uploadPDFAPI,
      onSectionSetting = false,
      disabled,
      formChange = () => {},
      data,
      afterChange = () => {},
      ...props
    },
    ref,
  ) => {
    const rowType = props.type;
    const location = useLocation();
    const onProjectCreating = location.pathname?.includes(
      '/create/moduleSetting',
    );
    const onSystemSetting = location.pathname?.includes(
      '/settings/systemModule',
    );
    const onProjectHome = location.pathname?.includes('/project-detail');
    const onMultisection = location.pathname?.includes('/multiSectionLink');
    const onSectionSorter = onSectionSetting || onProjectHome || onMultisection;

    const inputRef = useRef(null);
    if (shouldExtend) {
      activeId = document.activeElement.id;
    }
    useEffect(() => {
      if (activeId === inputRef.current?.props?.id) {
        inputRef.current.focus();
        setCaretPositionEnd(activeId);
      }
    }, [shouldExtend]);

    useEffect(
      () => () => {
        activeId = '';
      },
      [],
    );
    const changeLink = (projectId, id) => {
      const value =
        onSectionSorter || !id
          ? id
          : `/project/integrationModuleWithTab/${projectId}/pdf/${id}`;
      data.link = value;

      afterChange(data.moduleId || data.id, {
        [props?.colDef?.field?.[0]]: value,
      });
      formChange();
    };

    const onTextAreaChange = (v) => {
      const newData = {
        [props?.colDef?.field?.[0]]: v,
      };
      if (onProjectCreating && typeof data.isFromSystemModule === 'boolean') {
        newData.isFromSystemModule = false;
      }
      afterChange(data.moduleId || data.id, {
        ...newData,
      });
      formChange();
    };

    const changeImageLink = (path) => {
      const newData = {
        link: path !== '' ? path : '',
      };
      if (onProjectCreating && typeof data.isFromSystemModule === 'boolean') {
        newData.isFromSystemModule = false;
      }
      afterChange(data.moduleId || data.id, {
        ...newData,
        [props?.colDef?.field?.[0]]: path,
      });
      formChange();
    };

    const changeHtmlLink = (fileUrl) => {
      const path = fileUrl !== '' ? fileUrl : '';
      const newData = {
        link: path,
      };
      if (onProjectCreating && typeof data.isFromSystemModule === 'boolean') {
        newData.isFromSystemModule = false;
      }
      data.link = path;
      afterChange(data.moduleId || data.id, {
        ...newData,
        [props?.colDef?.field?.[0]]: path,
      });
      formChange();
    };
    const onTextContainerIdChange = (v) => {
      const newData = {};
      newData.link = v;
      if (onProjectCreating) {
        newData.isTemplate = true;
      }

      afterChange(data.moduleId || data.id, {
        ...newData,
        [props?.colDef?.field?.[0]]: v,
      });
      formChange();
    };
    const textContainerDisabled =
      rowType === INTEGRATION_TYPES.TEXT_CONTAINER && onSectionSorter;
    const shoudlDisabled =
      disabled ||
      textContainerDisabled ||
      [INTEGRATION_TYPES.CHART].includes(rowType);

    const moreProps = { ...props };
    if (rowType?.includes('powerbi')) {
      moreProps.placeholder = 'Insert a PowerBI Dashboard URL';
    }
    if (['text', 'regular', 'other'].includes(rowType)) {
      moreProps.placeholder = 'Insert an External URL';
    }
    if (rowType === 'pdf') {
      return (
        <UploadAndViewPdf
          {...props}
          changeLink={changeLink}
          shouldgetrReportPDF={onSectionSorter}
          uploadAPI={uploadPDFAPI}
        />
      );
    }
    if (rowType?.includes('image')) {
      return (
        <UploadAndViewImage {...props} changeImageLink={changeImageLink} />
      );
    }
    if (rowType === INTEGRATION_TYPES.HTML) {
      if (isHtmlModuleEnabled()) {
        return (
          <UploadAndViewHtml {...props} changeHtmlLink={changeHtmlLink} />
        );
      }
      return (
        <TextArea
          disabled
          placeholder="Not Applicable"
          className="textarea-extendable link-input-disabled"
        />
      );
    }
    if (
      rowType === INTEGRATION_TYPES.TEXT_CONTAINER &&
      !onProjectHome &&
      !onMultisection
    ) {
      return (
        <TextContainerInlineInput
          {...props}
          onChange={onTextContainerIdChange}
          isTemplate={onSystemSetting || onProjectCreating}
          onProjectCreating={onProjectCreating}
          data={data}
        />
      );
    }
    if (rowType === 'widget' || rowType === 'multiSection') {
      return (
        <TextArea
          disabled
          placeholder="Not Applicable"
          className="textarea-extendable link-input-disabled"
        />
      );
    }
    if (shoudlDisabled) {
      return (
        <TextArea
          disabled
          placeholder="Not Applicable"
          className="textarea-extendable link-input-disabled"
        />
      );
    }

    return shouldExtend ? (
      <LinkEditorPopup
        ref={inputRef}
        {...moreProps}
        onChange={onTextAreaChange}
      />
    ) : (
      <Input
        ref={inputRef}
        {...moreProps}
        style={{ textOverflow: 'ellipsis' }}
      />
    );
  },
);
export default ExtendableTextArea;
